import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M7.539 13.562v-2.814H4.853a.78.78 0 0 1-.662-1.193l1.217-1.948a.248.248 0 0 0 .027-.205h-.001L4.098 3.467l-.003-.01A1.123 1.123 0 0 1 5.167 2h5.668c.757 0 1.296.735 1.07 1.457l-.002.01-1.337 3.935-.011.053a.248.248 0 0 0 .037.152l1.218 1.948a.78.78 0 0 1-.662 1.193H8.414v2.814a.438.438 0 1 1-.875 0ZM5.167 2.875a.247.247 0 0 0-.237.32L6.267 7.13l.004.01c.097.313.054.653-.12.93L5.025 9.873h5.951L9.85 8.07a1.123 1.123 0 0 1-.12-.93l.004-.01 1.336-3.936a.247.247 0 0 0-.236-.32H5.168Z';
const draw24px =
  'M11.19 21.23v-4.627H6.496c-1.007 0-1.777-1.11-1.15-2.06l2.129-3.233a.318.318 0 0 0 .039-.277h-.001l-2.336-6.53-.006-.018C4.749 3.202 5.771 2 7.044 2h9.912c1.273 0 2.295 1.202 1.873 2.485l-.006.018-2.337 6.53-.015.069a.322.322 0 0 0 .054.208l2.13 3.232c.626.951-.144 2.061-1.151 2.061h-4.776v4.628a.77.77 0 0 1-1.538 0ZM7.044 3.539c-.342 0-.47.285-.412.465l2.337 6.53.006.018c.179.542.097 1.13-.215 1.604l-1.916 2.91h10.312l-1.916-2.91a1.856 1.856 0 0 1-.215-1.604l.006-.018 2.336-6.53c.06-.18-.07-.465-.411-.465H7.044Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PaperPinIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'paperPin'),
) as IconWithRender;

PaperPinIcon.displayName = 'PaperPinIcon';
PaperPinIcon.propTypes = Icon.propTypes;
PaperPinIcon.renderIcon = (props) => <PaperPinIcon {...props} />;
export default PaperPinIcon;
